import Component from '../inherited/Component'

export default class AnimationsReveal extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      distance: '100px',
      origin: 'bottom',
      delay: 200,
      duration: 800,
      opacity: 0,
      reset: true,
      showAbove: null,
      showBelow: null,
      easing: 'ease',
      afterReveal: el => {
        el.style.removeProperty('transition')
        el.removeAttribute('data-reveal')
      }
    }, ...this._options}
  }

  async mount () {
      const { default: ScrollReveal } = await import('scrollreveal')
      this._scrollReveal = ScrollReveal
      this._scrollReveal().reveal(this._elem, this._options)

      this._ctx.on('ffc--update-scrollreveal', (state, data) => {
          this._scrollReveal().sync()
      })
  }

  unmount () {
    if (this._scrollReveal) {
      this._scrollReveal().destroy();
    }
  }
}